Request Resume
<i-feather
  *ngIf="showIcon"
  name="file-text"
  class="small-icon position-relative"
  style="top: -1px;"
></i-feather>
